<template>
  <div>
    <b-form-input v-model="fiyatDegeri" @input="listeleTop" id="smallInput" />
    <perfect-scrollbar>
      <vs-table
        stripe
        :data="rowDatafiyat"
        height="50"
        style="padding-left: 20px"
      >
        <template slot="thead">
          <vs-th style="background: #9e95f5 !important" sort-key="FTUR"
            >Tür</vs-th
          >
          <vs-th style="background: #9e95f5 !important" sort-key="PRICE"
            >Fiyat</vs-th
          >

          <vs-th style="background: #9e95f5 !important" sort-key="IND1"
            >İndirim1</vs-th
          >
          <vs-th style="background: #9e95f5 !important" sort-key="IND2"
            >İndirim2</vs-th
          >
          <vs-th style="background: #9e95f5 !important" sort-key="IND3"
            >İndirim3</vs-th
          >
          <vs-th style="background: #9e95f5 !important"></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr
            :key="indextr"
            style="background: #c8c4ed !important"
            v-for="(tr, indextr) in data"
          >
            <vs-td :data="data[indextr].FTUR">
              {{ data[indextr].FTUR }}
            </vs-td>
            <vs-td :data="data[indextr].PRICE">
              {{ data[indextr].PRICE }}
            </vs-td>
            <vs-td :data="data[indextr].IND1">
              {{ data[indextr].IND1 }}
            </vs-td>

            <vs-td :data="data[indextr].IND2">
              {{ data[indextr].IND2 }}
            </vs-td>

            <vs-td :data="data[indextr].IND3">
              {{ data[indextr].IND3 }}
            </vs-td>

            <vs-td>
              <vs-button
                @click="fiyatSec(data[indextr])"
                icon="done"
                color="danger"
                type="flat"
              ></vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </perfect-scrollbar>
  </div>
</template>
<script>
import Store from "../../../../store/store";
import state from "../../../../store/state";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  data() {
    return {
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
      },
      fiyatDegeri: "",
      rowDatafiyat: [],
      dir: false,

      data: "",
    };
  },
  components: {
    VuePerfectScrollbar,
  },
  methods: {
    listeleTop() {
      this.$store.commit("account/SATINALMA_FIYAT", this.fiyatDegeri);
      this.setData(this.fiyatDegeri);
    },
    getValue() {
      return this.data;
    },
    setData(data) {
      this.data = data;
    },
    fiyatSec(data) {
      this.ftur = data.FTUR;
      this.$store.commit("account/SATINALMA_IND1", data.IND1);
      this.$store.commit("account/SATINALMA_IND2", data.IND2);
      this.$store.commit("account/SATINALMA_IND3", data.IND3);
      this.setData(data.PRICE);
    },

    rowStyleClassFn(row) {
      return "VGT-row";
    },
    isPopup() {
      // and we could leave this method out also, false is the default
      return true;
    },
  },
  created() {
    const selectedId = this.params.data.STOCKID;
    console.log(this.params.data)
    //  this.fiyatDegeri = this.params.data.fiyat;
    const soap = require("soap");
    const url = state.sistemAddress;
    var args = [];

    if (typeof this.params.data.cariAdi == "undefined") {
      args = {
        token: Store.state.tokenId,
        STOCKID: selectedId,
        ACTID: this.params.data.ACTID,
        STOCKGROUP: "MAKAS", //this.params.data.GROUPCODE,
      };
    } else {
      args = {
        token: Store.state.tokenId,
        STOCKID: selectedId,
        ACTID: this.params.data.ACTID,
        STOCKGROUP: "MAKAS", //this.params.data.GROUPCODE, //
      };
    }
    console.log(args)
    var vm = this;
    var dizi = [];
    soap.createClient(url, function (err, client) {
      client.INT_Ls_Stock_TalepStokSec(args, function (err, result) {
        if (result.INT_Ls_Stock_TalepStokSecResult == "-1") {
          Store.dispatch("logout");
          //this.$store.dispatch('login', payload)
        }
        try {
          vm.veriler = JSON.parse(result.INT_Ls_Stock_TalepStokSecResult);
          vm.rowDatafiyat = vm.veriler;
        } catch (error) {
          console.log(error);
        }
      });
    });
  },
};
</script>
<style lang="scss">
.VGT-row:hover {
  background-color: rgb(219, 219, 250);
}
.ps {
  height: 300px;
}
.scroll-area {
  position: relative;
  margin: auto;
  height: 300px;
}
</style>